import React from "react"

const ArrowLeft = ({
  style = {},
  pathFill ='#1C1C1E',
}: {
  style?: React.CSSProperties
  pathFill?: string
}) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g id="icon/24" clipPath="url(#clip0_332_359)">
        <path
          id="Vector"
          d="M19 11H7.82998L12.71 6.11997C13.1 5.72997 13.1 5.08997 12.71 4.69997C12.32 4.30997 11.69 4.30997 11.3 4.69997L4.70998 11.29C4.31998 11.68 4.31998 12.31 4.70998 12.7L11.3 19.29C11.69 19.68 12.32 19.68 12.71 19.29C13.1 18.9 13.1 18.27 12.71 17.88L7.82998 13H19C19.55 13 20 12.55 20 12C20 11.45 19.55 11 19 11Z"
          fill={pathFill}
        />
      </g>
      <defs>
        <clipPath id="clip0_332_359">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ArrowLeft
